import * as React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const FactCheckIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8075_7362)">
            <Path fillRule="evenodd" clipRule="evenodd" d="M13.332 2H2.66536C1.93203 2 1.33203 2.6 1.33203 3.33333V12.6667C1.33203 13.4 1.93203 14 2.66536 14H13.332C14.0654 14 14.6654 13.4 14.6654 12.6667V3.33333C14.6654 2.6 14.0654 2 13.332 2ZM6.66536 11.3333H3.33203V10H6.66536V11.3333ZM6.66536 8.66667H3.33203V7.33333H6.66536V8.66667ZM6.66536 6H3.33203V4.66667H6.66536V6ZM9.8787 10L7.9987 8.10667L8.9387 7.16667L9.8787 8.11333L11.992 6L12.9387 6.94667L9.8787 10Z" fill={customColor ?? "#521FAC"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8075_7362">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default FactCheckIcon;
